import React from 'react';
import { motion } from 'framer-motion';
import { Box, Container, Flex, Heading, Text, Button } from '@chakra-ui/react';
import { ArrowRight } from 'lucide-react';
const MotionBox = motion(Box);
export function FinalCTA() {
  return (
    <Box
      as="section"
      py={24}
      borderTop="1px solid"
      borderColor="brand.border"
      position="relative"
      overflow="hidden">
      
      <Box position="absolute" inset={0} bg="rgba(16, 185, 129, 0.05)" />
      <Box
        position="absolute"
        bottom={0}
        left="50%"
        transform="translateX(-50%)"
        w="600px"
        h="300px"
        bg="rgba(16, 185, 129, 0.2)"
        filter="blur(100px)"
        borderRadius="full"
        pointerEvents="none" />
      

      <Container maxW="container.xl" px={4} position="relative" zIndex={10}>
        <MotionBox
          initial={{
            opacity: 0,
            y: 20
          }}
          whileInView={{
            opacity: 1,
            y: 0
          }}
          viewport={{
            once: true
          }}
          maxW="3xl"
          mx="auto"
          textAlign="center">
          
          <Heading
            as="h2"
            fontSize={{
              base: '4xl',
              md: '5xl'
            }}
            fontWeight="bold"
            mb={6}>
            
            Stop appealing blind. <br />
            <Text as="span" color="brand.green">
              Fix the real problem first.
            </Text>
          </Heading>

          <Flex mt={10} direction="column" align="center" gap={6}>
            <Button
              display="inline-flex"
              alignItems="center"
              justifyContent="center"
              gap={2}
              px={10}
              py={5}
              h="auto"
              fontSize="xl"
              fontWeight="bold"
              color="brand.dark"
              bg="brand.green"
              borderRadius="xl"
              w={{
                base: 'full',
                sm: 'auto'
              }}
              _hover={{
                bg: 'brand.greenHover',
                boxShadow: 'glow-strong',
                transform: 'scale(1.05)'
              }}
              transition="all 0.2s">
              
              <Text as="span">Scan My Store</Text>
              <ArrowRight size={24} />
            </Button>

            <Flex
              flexWrap="wrap"
              justify="center"
              gap={6}
              color="gray.400"
              fontWeight="medium">
              
              <Text as="span">One-time audit.</Text>
              <Text as="span">No subscription.</Text>
              <Text as="span">No guesswork.</Text>
            </Flex>
          </Flex>
        </MotionBox>
      </Container>
    </Box>);

}